import axios from 'axios';
import { configRefs } from '@utils/constants';

async function fetchDialoguesRequest(dialogueId) {
  const res = await axios.get(`${await configRefs.apis.userdata.get()}/api/Dialogues/${dialogueId}`);
  const dialogueOwner = res.data.authors.find(it => it.id === res.data.userID);
  return res.data.messages.map(it => {
    if (!it.content || it.content.trim() === "") {
      return undefined;
    }
    if (it.author.type === "system") {
      return {
        id: `${it.content}-${it.createdDate}`,
        type: "event",
        author: dialogueOwner,
        eventType: it.content.includes("Opdateret") ? "edited" : "shared",
        timestamp: new Date(it.createdDate * 1000)
      };
    } else if (it.content !== null) {
      const authorId = it.author.id;
      return {
        id: `${it.content}-${it.createdDate}`,
        type: "message",
        author: {
          ...res.data.authors.find(author => author.id === authorId),
          role: it.author.type
        },
        plainTextContent: it.content,
        timestamp: new Date(it.createdDate * 1000),
        state: "sent"
      };
    }
  }).filter(it => !!it);
}

export { fetchDialoguesRequest };
//# sourceMappingURL=api.get-dialogues.request.js.map
